export default {
  STANDARD_DATE: 1,
  WEEKDAY_DATE: 2,
  MONTH: 3,
  WEEKDAY_LABEL: 4,
  WEEKDAY_LABEL_ABBR: 5,
  TABLE_CELL_LABEL: 6,
};
